import { BarChart3, FileStack, LayoutPanelTop, ShieldCheck, UsersRound } from "lucide-react";
import { Link } from "react-router-dom";

const navigationItems = [
  ["Dashboard", "/admin", LayoutPanelTop, "admin-dashboard-link"],
  ["Content", "/admin/content", FileStack, "admin-content-link"],
  ["Operations", "/admin/operations", BarChart3, "admin-operations-link"],
  ["Access", "/admin/access-policy", UsersRound, "admin-access-policy-link"],
  ["Security", "/admin/security", ShieldCheck, "admin-security-link"],
];

export default function AdminControlNavigation({ active }) {
  return (
    <nav className="admin-control-navigation" aria-label="Control Room navigation" data-testid="admin-control-navigation">
      {navigationItems.map(([label, path, Icon, testId]) => (
        <Link key={path} className={active === label.toLowerCase() ? "active" : ""} to={path} data-testid={testId}>
          <Icon size={15} />
          {label}
        </Link>
      ))}
      <Link to="/admin/renderings" className={active === "renderings" ? "active" : ""} data-testid="admin-renderings-link">Renderings</Link>
    </nav>
  );
}